/** @jsxImportSource @emotion/react */
import { Boton, useFuncionalidad, deOrganismo, useOrganismo } from "../../shared";
import { Divider } from "primereact/divider";

export default function DescargasDelCertificado({
  detallesCertificado,
  loaderDescarga,
  loaderDescargaMarca,
  descargarCertificado,
  descargarMarca,
  descargarMarcadoProducto,
  descargarEtiqueta,
}) {
  // Nombre del organismo (multitenant: nada de un organismo fijo)
  const organismo = useOrganismo();
  // El párrafo del reglamento de URSEA solo para organismos con esa funcionalidad
  const conUrsea = useFuncionalidad("URSEA");
  return (
    <div>
      {detallesCertificado.emisioncertificado[0]?.archivopdf
        ?.nombredescarga && (
        <div>
          <h3>Certificado en PDF</h3>
          <p>
            El certificado es el documento final de la certificación, tiene toda
            la información referente al alcance y validez de la certificación.
          </p>
          <p>
            Los certificados {deOrganismo(organismo)} tienen un
            vínculo al registro digital del certificado, a fin de mantener una
            corroboración en tiempo real del estado y el alcance del
            certificado. El documento por sí mismo necesita el soporte de la
            información en la plataforma digital.
          </p>
          <Boton loader={loaderDescarga} callback={descargarCertificado}>
            Descargar certificado en PDF
          </Boton>
          <Divider />
        </div>
      )}
      <div>
        <h3>Marca de conformidad</h3>
        <p>
          La marca de conformidad es el indicador de que el producto está
          certificado y cumple con los requerimientos correspondientes. Tiene
          referencia al número de certificado y le permite al consumidor
          corroborar el estado del certificado.
        </p>
        <p>
          Puede utilizarse sobre el producto certificado así como en material
          promocional.
        </p>
        <Boton callback={descargarMarca} loader={loaderDescargaMarca}>
          Descargar marca de conformidad
        </Boton>
        <Divider />
        <h3>Detalles de la empresa</h3>
        <p>
          Debajo podrá descargar una etiqueta con el nombre y dirección legal
          del propietario del certificado, así como la marca de certificación y
          el código QR de vínculo al repositorio digital del certificado. Puede
          utilizar esta etiqueta libremente en empaques o en el propio producto.
        </p>
        {conUrsea && (
          <p>
            El Reglamento de Seguridad de Productos Eléctricos de Baja Tensión de
            URSEA exige el marcado de los datos del importador en el empaque
            primario del producto, esta etiqueta cumple esos requerimientos.
          </p>
        )}
        <Boton callback={descargarMarcadoProducto} loader={loaderDescargaMarca}>
          Descargar etiqueta de marcado
        </Boton>
      </div>
    </div>
  );
}
